//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { SendEmailResultItem } from './SendEmailResultItem';

export class SendChangePasswordEmailResultItem extends SendEmailResultItem {
    RecipientIDsWithAccessDisabled: string[] = [];

    constructor(initializer?: Partial<SendChangePasswordEmailResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SendChangePasswordEmailResultItem";
}
